import { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { DateFormat } from "../../services/dateFormat";
import { saveToJPG } from "../../services/saveToImage";
import { useAlert } from "../../contexts/alertContext";
//import axiosInstance from "../../connections/axiosInstance";
import japanitipLogo from "../../assets/logo/japanitip.png"
import { Price } from "../../services/price";

const ITEM = {
    _id: Date.now() + Math.random().toString(36),
    name: "",
    qty: "",
    note: "pcs",
    price: "",
};

const INVOICE = {
    name: "",
    currency: "JPY",
    rate: 105,
    price: 0,
    deposit: 0,
};

const Input = ({ onChange, placeholder, name, value, currency, disabled }) => {
    return (
        <div className="p-1.5 px-2 rounded-md outline-[var(--blue)] border border-[var(--gray-light)] w-full my-1 flex gap-2.5">
            <span className="text-[var(--gray)] border-r pr-2.5 hidden md:block">{currency}</span>
            <input
                type="text"
                className="outline-none w-full"
                placeholder={placeholder}
                value={value}
                name={name}
                onChange={onChange}
                disabled={disabled}
            />
        </div>
    );
};

export default function CreateInvoice() {
    const [items, setItems] = useState(() => {
        // get items history
        const sessionData = sessionStorage.getItem("invoice");
        const invoice = sessionData && JSON.parse(sessionData);

        return invoice?.items ? invoice.items : [ITEM];
    });

    const [invoice, setInvoice] = useState(() => {
        // get invoice history
        const sessionData = sessionStorage.getItem("invoice");
        return sessionData ? JSON.parse(sessionData) : INVOICE;
    });

    const [isSubmit, setIsSubmit] = useState(false);
    const regex = /^[+-]?(\d{1,3})(?:,(\d{3}))*([\.\d]*)$/; // eslint-disable-line
    const savedElement = useRef();
    const { alertHandler } = useAlert();
    const currentTime = new DateFormat(new Date().getTime())
    const price = new Price({invoice, items})

    function changeHandler(event) {
        // change handler
        const { name, value } = event.target;
        let inputData;

        if (["rate", "deposit"].includes(name)) {
            inputData = { ...invoice, [name]: regex.test(value) ? value : "" };
        }
        inputData = { ...invoice, [name]: value };

        setInvoice(inputData);
        return sessionStorage.setItem("invoice", JSON.stringify({ ...inputData, items }));
    }

    function itemChangeHandler(event, _id) {
        // items change handler
        const { name, value } = event.target;
        let inputData = items?.map((item) => {
            if (item._id === _id) {
                if (["price", "qty"].includes(name)) {
                    return { ...item, [name]: regex.test(value) ? value : "" };
                }
                return { ...item, [name]: value };
            }
            return item;
        });

        setItems(inputData);
        return sessionStorage.setItem("invoice", JSON.stringify({ ...invoice, items: inputData }));
    }

    function addMoreItem() {
        // add more item
        setItems((prev) => [...prev, { ...ITEM, _id: Date.now() + Math.random().toString(36) }]);
    }

    function deleteItem(_id) {
        // delete item
        setItems((prev) => prev?.filter((item) => item._id !== _id));
    }

    function resetHandler() {
        // reset all
        setInvoice(INVOICE);
        setItems([ITEM]);
        return sessionStorage.setItem("invoice", JSON.stringify({ ...INVOICE, items: [ITEM] }));
    }

    async function submitHandler() {
        // submit invoice
        if (!invoice.name) {
            return alertHandler({ status: 2, message: "Invoice saved failed, invoice name is required" });
        }
        try {
            setIsSubmit(true);
            
            //const invoiceData = { ...invoice, items };
            // post new invoice
            //await axiosInstance.post("/invoice", invoiceData)
            // download invoice as JPG
            saveToJPG(savedElement, invoice.name);
            alertHandler({ status: 1, message: "Invoice saved successfully" });
        } catch (error) {
            console.log(error);
            alertHandler({ status: 2, message: "Invoice saved failed" });
        }
        setIsSubmit(false);
    }

    return (
        <main className="md:grid grid-cols-2 gap-5 w-full capitalize">
            <section className="p-3.5 md:rounded-xl bg-white w-full h-max shadow">
                <h1 className="font-bold mb-4">CREATE INVOICE</h1>
                <div className="md:grid grid-cols-2 gap-5 my-4 border-b pb-5">
                    <div className="">
                        <label htmlFor="" className="whitespace-nowrap">
                            invoice to
                        </label>
                        <input
                            name="name"
                            className="p-1.5 px-2 rounded-md outline-none border border-[var(--gray-light)] w-full my-1"
                            placeholder="Budiono siregar"
                            value={invoice.name}
                            onChange={changeHandler}
                        />
                    </div>
                    <div className="">
                        <label htmlFor="">currency</label>
                        <select
                            name="currency"
                            value={invoice.currency}
                            onChange={changeHandler}
                            className="bg-transparent w-full border rounded-md p-2 my-1.5 optional:bg-white"
                        >
                            <option value="JPY">JPY</option>
                            <option value="IDR">IDR</option>
                        </select>
                    </div>
                    <div className="">
                        <label htmlFor="">rate</label>
                        <Input
                            name="rate"
                            currency={invoice.currency}
                            onChange={changeHandler}
                            value={invoice.rate}
                        />
                    </div>
                    <div className="">
                        <label htmlFor="">deposit</label>
                        <Input
                            name="deposit"
                            currency={invoice.currency}
                            onChange={changeHandler}
                            value={invoice.deposit}
                        />
                    </div>
                </div>
                <div className="border-b overflow-x-auto w-full overflow-auto">
                    <h1 className="font-bold mb-4">INVOICE ITEMS</h1>
                    <table className="w-full text-left table-auto invoice_table_input">
                        <thead className="w-full">
                            <tr className="text-bold">
                                <th>description</th>
                                <th>QTY</th>
                                <th>price</th>
                                <th className="md:block hidden">amount</th>
                                <th>action</th>
                            </tr>
                        </thead>
                        <tbody className="w-max">
                            {items?.map((item) => (
                                <tr key={item._id} className="w-max">
                                    <td>
                                        <input
                                            type="text"
                                            name="name"
                                            className="outline-none p-0"
                                            placeholder="Item description"
                                            value={item.name}
                                            onChange={(event) => itemChangeHandler(event, item._id)}
                                        />
                                    </td>
                                    <td className="">
                                        <div className="flex">
                                            <input
                                                type="text"
                                                name="qty"
                                                className="bg-transparent w-10 outline-none p-0"
                                                value={item.qty}
                                                placeholder="Qty"
                                                onChange={(event) => itemChangeHandler(event, item._id)}
                                            />
                                            <select
                                                name="note"
                                                onChange={(event) => itemChangeHandler(event, item._id)}
                                                value={item.note}
                                                className="uppercase bg-white border-l pl-2 w-12 text-xs"
                                            >
                                                <option value="kg">kg</option>
                                                <option value="pair">pair</option>
                                                <option value="pcs">pcs</option>
                                                <option value="slop">slop</option>
                                            </select>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="">
                                            <input
                                                value={item.price}
                                                className="outline-none p-0 font-semibold w-full"
                                                onChange={(event) => itemChangeHandler(event, item._id)}
                                                placeholder={invoice.currency}
                                                name="price"
                                            />
                                        </div>
                                    </td>
                                    <td className="max-[768px]:hidden">
                                        <div className="flex gap-2">
                                            <span className="text-[var(--gray)]">{invoice.currency}</span>
                                            <input
                                                currency={invoice.currency}
                                                value={item.price * item.qty}
                                                className="font-semibold w-3/4 text-right"
                                                disabled={true}
                                                placeholder="Amount"
                                            />
                                        </div>
                                    </td>
                                    <td className="p-0 text-center">
                                        <button
                                            className="underline text-[var(--red)] w-10"
                                            onClick={() => deleteItem(item._id)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button className="text-[var(--blue-dark)] underline p-2 my-3.5" onClick={addMoreItem}>
                        Add more item
                    </button>
                </div>
                <div className="my-4 md:flex gap-4 font-semibold">
                    <button className="border-2 rounded-lg p-2 w-full mb-4 md:mb-0" onClick={resetHandler}>
                        RESET
                    </button>
                    <button
                        className="p-2 w-full rounded-lg "
                        style={{
                            background: isSubmit ? "var(--gray-light)" : "var(--blue)",
                            color: isSubmit ? "var(--gray)" : "white",
                        }}
                        onClick={submitHandler}
                    >
                        {isSubmit ? <FontAwesomeIcon icon={faEllipsis} /> : "SAVE & DOWNLOAD"}
                    </button>
                </div>
            </section>
            <section className="p-3.5 md:rounded-xl bg-white w-full h-max shadow capitalize overflow-x-scroll">
                <h1 className="font-bold mb-4">INVOICE PREVIEW</h1>
                <div id="invoice" ref={savedElement} className="p-5 w-max md:w-full bg-white">
                    <section className=" py-4 gap-5">
                        <div className="flex justify-between items-start">
                            <div className="text-5xl font-bold">INVOICE</div>
                            <div className="lowercase w-full text-right">
                                <div className=" gap-1">
                                    <FontAwesomeIcon icon={faGlobe} className="mr-2" />
                                    <span>www.japanitip.id</span>
                                </div>
                                <div className="gap-1">
                                    <FontAwesomeIcon icon={faInstagram} className="mr-2" />
                                    <span>japanitip.id</span>
                                </div>
                                <div className="gap-1">
                                    <FontAwesomeIcon icon={faWhatsapp} className="mr-2" />
                                    <span>+62 821-1546-9622</span>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="grid grid-cols-2 gap-5 border-y p-4 ">
                        <div className="">
                            <h2 className="font-semibold text-[var(--gray)]">invoice to</h2>
                            <div className="font-bold">{invoice.name}</div>
                        </div>
                        <div className="">
                            <h2 className="font-semibold text-[var(--gray)]">invoice date</h2>
                            <div className="font-bold">{currentTime.display()}</div>
                        </div>
                        <div className="">
                            <h2 className="font-semibold text-[var(--gray)]">currency</h2>
                            <div className="font-bold">{invoice.currency}</div>
                        </div>
                        <div className="">
                            <h2 className="font-semibold text-[var(--gray)]">rate</h2>
                            <div className="font-bold">IDR {invoice.rate}/1 JPY</div>
                        </div>
                    </section>
                    <section className="py-5 border-b">
                        <table className="w-full text-left">
                            <thead>
                                <tr className="bg-[var(--red)] text-[var(--white)]">
                                    <th>description</th>
                                    <th>QTY</th>
                                    <th>price</th>
                                    <th>total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items?.map((item) => (
                                    <tr className="border-b bg-[var(--background)]" key={item._id}>
                                        <td>{item.name}</td>
                                        <td>
                                            {item.qty} <span>{item.note}</span>
                                        </td>
                                        <td>
                                            <div>
                                                <span className="font-semibold">
                                                    {price.format(item.price)}
                                                </span>
                                            </div>
                                            <div className="text-[var(--gray)] text-xs opacity-50">
                                                <span className="">
                                                    {price.detail(item.price)}
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <span className="font-semibold">
                                                    {price.format(item.price * item.qty)}
                                                </span>
                                            </div>
                                            <div className="text-[var(--gray)] text-xs opacity-50">
                                                <span className="">
                                                    {price.detail(item.price * item.qty)}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td>subtotal</td>
                                    <td>
                                        <div>
                                            <span className="font-semibold">
                                                {price.subtotal(items).subtotal}
                                            </span>
                                        </div>
                                        <div className="text-[var(--gray)] text-xs opacity-50">
                                            <span className="">{price.subtotal(items).detail}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td>deposit</td>
                                    <td>
                                        <div>
                                            <span className="font-semibold">
                                                {price.format(invoice.deposit)}
                                            </span>
                                        </div>
                                        <div className="text-[var(--gray)] text-xs opacity-50">
                                            <span className="">{price.detail(invoice.deposit)}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="font-bold">
                                    <td></td>
                                    <td></td>
                                    <td>grand total</td>
                                    <td>
                                        <div>
                                            <span className="font-semibold">
                                                {price.total().total}
                                            </span>
                                        </div>
                                        <div className="text-[var(--gray)] text-xs opacity-50">
                                            <span className="">
                                                {price.total().detail}
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </section>
                    <section className="my-10 flex gap-5">
                        <table className="border whitespace-nowrap bank_account_table w-max">
                            <thead className="bg-[var(--red)] text-[var(--white)] text-left">
                                <tr>
                                    <th>Paymnet Information</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="font-semibold text-center">ASIH MEITARY</td>
                                    <td></td>
                                </tr>
                                <tr className="">
                                    <td>BCA</td>
                                    <td>7391925694</td>
                                </tr>
                                <tr className="">
                                    <td>BRI</td>
                                    <td>405401011987533</td>
                                </tr>
                                <tr className="border-b">
                                    <td>SMBC</td>
                                    <td>90270540166</td>
                                </tr>
                               <tr>
                                    <td className="font-semibold text-center">MQ Co., Ltd</td>
                                    <td></td>
                                </tr>
                                <tr className="">
                                    <td>Osaka Shinkin Bank</td>
                                    <td>003-0989897-0132865</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="w-full text-center">
                            <img src={japanitipLogo} className="w-52 my-5 m-auto" alt=""/>
                            <div>- Thank you -</div>
                        </div>
                    </section>
                </div>
            </section>
        </main>
    );
}
